import {getDefaultCss} from '../annotation/utils/getDefaultCss'
import {embeddedFormStyleProperties} from './embeddedFormStyleProperties'

export const defaultEmbeddedFormCss = getDefaultCss(embeddedFormStyleProperties)
